// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./ConfigHeader.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  RootPrimitive,
  SpacerPrimitive,
  TextPrimitive,
} from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      "67qGTpobMf": {
        none: {
          text: "Lorem Ipsum",
        },
      },
      NSzTyKLQ9X: {
        none: {
          text: "Dolor sit amet lorem ipsum",
        },
      },
    },
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const ConfigHeaderContext = createContext(null);

function ConfigHeader(_props) {
  const defaults = useContext(ConfigHeaderContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="FvWqhpQeXT"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "FvWqhpQeXT",
        scope: "46qstSMFiX",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <TextPrimitive
            id={"title_67qGTpobMf"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_46qstSMFiX_67qGTpobMf"
            }
            key={"67qGTpobMf"}
            text={
              exists(props.title) ? props.title : getStyle("67qGTpobMf", "text")
            }
            element={getStyle("67qGTpobMf", "htmlElement")}
          />
          <SpacerPrimitive
            id={"Spacer_LGqDJSXnxo"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_46qstSMFiX_LGqDJSXnxo"
            }
            key={"LGqDJSXnxo"}
          />
          <TextPrimitive
            id={"subtitle_NSzTyKLQ9X"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_46qstSMFiX_NSzTyKLQ9X"
            }
            key={"NSzTyKLQ9X"}
            text={
              exists(props.subtitle)
                ? props.subtitle
                : getStyle("NSzTyKLQ9X", "text")
            }
            element={getStyle("NSzTyKLQ9X", "htmlElement")}
          />
        </>
      )}
    </RootPrimitive>
  );
}

ConfigHeader.__variants = [];

export default ConfigHeader;
